import { useCallback } from 'react';

export const useHaptic = () => {
  const trigger = useCallback((pattern: number | number[]) => {
    if (typeof window !== 'undefined' && 'vibrate' in navigator) {
      try {
        navigator.vibrate(pattern);
      } catch (err) {
        // Suppress errors if vibration is blocked or unsupported
        console.warn('Haptic feedback error:', err);
      }
    }
  }, []);

  const lightTap = useCallback(() => trigger(10), [trigger]);
  const mediumTap = useCallback(() => trigger(25), [trigger]);
  const success = useCallback(() => trigger([15, 30, 15]), [trigger]);
  const error = useCallback(() => trigger([40, 60, 40]), [trigger]);
  const invalidAlert = useCallback(() => trigger([30, 40, 30, 40]), [trigger]);

  return {
    trigger,
    lightTap,
    mediumTap,
    success,
    error,
    invalidAlert,
  };
};

// Global export of haptic trigger for non-React files or legacy elements
export const triggerHaptic = (pattern: number | number[]) => {
  if (typeof window !== 'undefined' && 'vibrate' in navigator) {
    try {
      navigator.vibrate(pattern);
    } catch {}
  }
};
